import { Message } from 'element-ui';

import Vue from "vue"
/** 复制粘贴 */
export class CopyTable {
  constructor(e, tableData, rowIndex, columnIndex, props,noWrites) {
    this.tableData = JSON.parse(JSON.stringify(tableData))
    this.columnIndex = columnIndex
    this.rowIndex = rowIndex
    this.$set = Vue.set
    this.props = props || null
    this.noWrites=noWrites||[]
  this.pasteInfo(e)


  }
  // 处理对象内部的字段 按顺序
  initObj(editObj) {
    
    const keys = Object.keys(this.props || editObj)
    let emptyObj = {}
    keys.map(it => {
      emptyObj[it] = JSON.parse(JSON.stringify(editObj))[it]
    })
    return emptyObj
  }
  pasteInfo(e) {
    try {
      e.preventDefault(); //阻止默认粘贴事件
      e.stopPropagation(); //阻止事件冒泡

      var data = null;
      var clipboardData = e.clipboardData || window.clipboardData; // IE
      if (!clipboardData) {
        //chrome
        clipboardData = e.originalEvent.clipboardData;
      }
      data = clipboardData.getData("Text"); //复制过来的内容
      //首先对源头进行解析
      if (data && !data.includes('\r\n')) { // 单独复制文本，不是复制单个单元格
        data = data + '\r\n'
      }
      var rowStrArray = data.split("\r\n"); //拆成多行
      let rows = [];
      for (var i = 0; i < rowStrArray.length - 1; i++) {
        var row = [];
        var tdStrArray = rowStrArray[i].split("\t"); //按列拆分
        for (var j = 0; j < tdStrArray.length; j++) {
          row.push(tdStrArray[j]);
        }
        rows.push(row);
      }
      // @paste.native="(e)=>parent.vueInst().$copyVxeTable(e,getTableRef(),rowIndex,columnIndex-2)"

          let emptyObj = this.initObj(this.tableData[this.rowIndex])
      // 可能会有数据 给空对象复制
      for (var j = 0; j < rows.length; j++) {
        if (this.rowIndex + j > this.tableData.length - 1) {
          // console.log(rows.length)
          //   console.log(this.tableData.length)
          // console.log(rows,'---------rows')
          // break
          this.tableData.push({})
        }
        let item = {}
        item = this.initObj(this.tableData[this.rowIndex + j])
      
          console.log(this.noWrites)
        let num = 0
        let numFlag = 0 //从哪一列开始粘贴：全部列都可以粘贴(即从第0列可以粘贴)
        for (var key in emptyObj) {
          if (!rows[j][num] &&rows[j][num]!=="" ) {
            break
          }
          // console.log('numFlag--', numFlag, 'this.columnIndex--', this.columnIndex, 'num-', num);
          if (this.columnIndex <= numFlag) {
            // 针对不能修改的列字段做处理，可以复制粘贴的列才做赋值。根据需求加下面的if判断
            if(!this.noWrites.includes(key)){
              console.log(key)
              item[key] = rows[j][num]
            } 
           
            num = num + 1
          }
          numFlag = numFlag + 1
        }
        this.$set(this.tableData, this.rowIndex + j, item)
      }
    } catch (err) {
      console.log(err)
      Message.error('请选择粘贴位置')
    }
  }
}

//  @paste.native="(e)=>parent.vueInst().$copyVxeTable(e,getTableRef(),rowIndex,columnIndex-2)"

//  复制el-table的相关业务逻辑
export const copyElTable = (e, data, rowIndex, columnIndex) => {
  const { tableData } = new CopyTable(e, data, rowIndex, columnIndex)
  return tableData
}
export const copyVxeTable = (e, table, rowIndex, columnIndex,copyConfig) => {
  
  if(!copyConfig.able){
    return false
  }
  // console.log(e)
  // return 
  table.createRow().then(res => {
    const data = table?.getTableData()?.fullData
    if (data.length) {
      const { tableData } = new CopyTable(e, data, rowIndex, columnIndex, res,copyConfig.ignoreArr)
      table.reloadData(tableData)
      console.log(tableData)
      return tableData

    }
  })

}